import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Body from "./components/Body";
import Eventos from "./components/Events/Events.js";
import Members from "./components/Members/Members";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider, useAuthProvider } from "./customHooks/authContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import Users from "./components/Users/Users.js";
import Schools from "./components/Schools/Schools.js";
import EventTable from "./components/Events/EventsTable";
import EventEdit from "./components/Events/EventEdit";
import Registration from "./components/Registrations/Registration"
import Performances from "./components/performance/Performances.js";
import Courses from "./components/Courses/Courses.js";
import Payments from "./components/Payments/Payments.js";
import Modalities from "./components/Settings/Modalities.js";
import Forms from "./components/Settings/Forms.js";
import Registrations from "./components/EventOrganization/Registrations.js";
import PerformancesOrder from "./components/EventOrganization/performanceOrder/PerformancesOrder.js";
import Credentials from "./components/EventOrganization/Credentials.js";
import Accreditations from "./components/EventOrganization/Accreditations.js";
import Reports from "./components/EventOrganization/Reports.js";
import ManagementPerformances from "./components/EventOrganization/ManagementPerformances.js";
import AwardAllocation from "./components/SettingsAward/AwardAllocation.js";
import PrizeCalculator from "./components/SettingsAward/PrizeCalculator.js";
import AwardConsultation from "./components/SettingsAward/AwardConsultation.js";
import ManagementPayments from "./components/Payments/ManagementPayments.js";
import CoursesAdm from "./components/Courses/CoursesAdm.js";
import CoursesParticipants from "./components/Courses/CoursesParticipants.js";
import FinancialMovements from "./components/Payments/FinancialMovements.js";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CoursesParticipantsEdit from "./components/Courses/CoursesParticipantsEdit.js";
import Certificates from "./components/Certificates/Certificates.js";

function AppContent() {
  const { isAuthenticated, role } = useAuthProvider();

  return (
    <Router>
      <Routes>
        {/* Redirección raíz según el rol */}
        <Route
  path="/"
  element={
    isAuthenticated ? (
      role.includes("Administrador") || role.includes("Operador") ? (
        <Navigate to="/events" replace />
      ) : role.includes("Escuela") ? (
        <Navigate to="/obras" replace />
      ) : (
        <Navigate to="/members" replace />
      )
    ) : (
      <Navigate to="/login" replace />
    )
  }
/>


        {/* Ruta pública de Login */}
        <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} />

        {/* Rutas protegidas normales */}
        <Route
          path="/members"
          element={
            <ProtectedRoute>
              <Body>
                <Members />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/registration"
          element={
            <ProtectedRoute>
              <Body>
                <Registration />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/performance"
          element={
            <ProtectedRoute>
              <Body>
                <Performances />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/course"
          element={
            <ProtectedRoute>
              <Body>
                <Courses/>
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <Body>
                <Payments/>
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/certificates"
          element={
            <ProtectedRoute>
              <Body>
                <Certificates/>
              </Body>
            </ProtectedRoute>
          }
        />

        {/* Rutas solo para administradores */}
         <Route path="/events" element={
          <ProtectedRoute allowedRoles={["Administrador", "Operador"]}>
            <Body><Eventos /></Body>
          </ProtectedRoute>
        } />
        
        <Route
          path="/settings/modalities"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Modalities />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings/forms"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Forms />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Users />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/registrations"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Registrations />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/performancesorder"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <PerformancesOrder />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/credentials"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Credentials />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/accreditations"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Accreditations />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/reports"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <Reports />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/eventorganization/managementperformances"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <ManagementPerformances />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesadm"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <CoursesAdm />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesparticipantsedit"
          element={
            <ProtectedRoute adminOnly operatorOnly>
              <Body>
                <CoursesParticipantsEdit />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/awardallocation"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <AwardAllocation />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/prizecalculator"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <PrizeCalculator />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settingsaward/awardconsultation"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <AwardConsultation />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/managementpayments"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <ManagementPayments />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments/financialmovements"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <FinancialMovements />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <Schools />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <ProtectedRoute adminOnly>
              <Body>
                <Members />
              </Body>
            </ProtectedRoute>
          }
        />
        <Route
          path="/courses/coursesparticipants"
          element={
            <ProtectedRoute>
              <Body>
                <CoursesParticipants/>
              </Body>
            </ProtectedRoute>
          }
        />



                {/* Rutas solo para escuelas */}
                <Route
          path="/obras"
          element={
            <ProtectedRoute schoolOnly>
              <Body>
                <EventTable />
              </Body>
            </ProtectedRoute>
          }/>

        {/* Edición de eventos */}
        <Route
          path="/edit-event/:id"
          element={
            <ProtectedRoute>
              <Body>
                <EventEdit />
              </Body>
            </ProtectedRoute>
          }
        />

        {/* Ruta por defecto si no coincide ninguna */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}
function App() {
  return (
    <AuthProvider>
      <AppContent />
       <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
}

export default App;
